import { ArrowRightIcon } from '../components/icons';
import { AppDownloadButtons } from '../components/AppDownloadButtons';
import heroPhoto from '../assets/photography/rdne-diverse-friends-van.jpg';
import './Hero.css';

export const Hero = () => (
  <section className="tl-hero" id="top" aria-labelledby="tl-hero-heading">
    <div className="tl-hero__inner tl-shell">
      <div className="tl-hero__copy">
        <p className="tl-eyebrow tl-hero__eyebrow">One journey · shared in real time</p>
        <h1 id="tl-hero-heading" className="tl-hero__heading">
          Enjoy the journey. Know where everyone is.
        </h1>
        <p className="tl-lede tl-hero__lede">
          Tulink keeps your group connected from departure to arrival.
        </p>
        <div className="tl-hero__actions">
          <AppDownloadButtons />
          <a className="tl-textlink" href="#journey">
            See how it works
            <ArrowRightIcon />
          </a>
        </div>
      </div>
    </div>

    <figure className="tl-hero__figure">
      <img
        className="tl-photo tl-hero__photo"
        src={heroPhoto}
        alt="Three friends laughing together in the front of a van as they set off on a journey."
        width={1125}
        height={750}
        decoding="async"
      />
    </figure>
  </section>
);
